<div class="d-flex align-items-center">
  <img
    [src]="logoHeuresInsertionUrl"
    alt="Logo"
    class="logo-img me-2"
    style="width: 125px; height: 125px; object-fit: contain;"
  />
  <a class="navbar-brand title">
    Suivi des heures d’insertion
    <span class="d-block">
      professionnelle sur chantier
    </span>
  </a>
</div>
